<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='14'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 何宽
 * 矿产品管理页面
 */
import {mapState} from 'vuex'
import KcpAdd from '../../../../static/form/KcpAdd.vue'
import KcpLB from '../assembly/KcpLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import Classification from '../assembly/Classification.vue'
export default {
  components: {
    KcpAdd,
    KcpLB,
    ComboBox,
    Classification
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '矿产品列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: KcpLB
      },
      {
        title: '分类管理列表',
        name: '2',
        closable: false,
        content: Classification
      }],
      addobj: {
        title: '添加矿产品',
        name: '3',
        closable: true,
        content: KcpAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Kcpgl.vue